<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->

<template>
  <div class="min-h-screen bg-gray-50 p-8">
    <!-- 数据概览卡片 -->
    <div class="grid grid-cols-4 gap-6 mb-6">
      <div
        v-for="(card, index) in statisticsCards"
        :key="index"
        class="bg-white rounded-lg shadow-sm p-6"
      >
        <div class="flex items-center justify-between">
          <span class="text-gray-600">{{ card.title }}</span>
          <el-icon :class="card.iconClass"
            ><component :is="card.icon"
          /></el-icon>
        </div>
        <div class="mt-4">
          <span class="text-2xl font-bold">{{ card.value }}</span>
          <span
            :class="[
              'ml-2 text-sm',
              card.trend > 0 ? 'text-green-500' : 'text-red-500'
            ]"
          >
            {{ card.trend > 0 ? "+" : "" }}{{ card.trend }}%
          </span>
        </div>
      </div>
    </div>

    <!-- 图表区域 -->
    <div class="grid grid-cols-2 gap-6 mb-6">
      <div class="bg-white rounded-lg shadow-sm p-6">
        <h3 class="text-lg font-medium mb-4">会员活动趋势</h3>
        <div ref="trendChart" class="h-80"></div>
      </div>
      <div class="bg-white rounded-lg shadow-sm p-6">
        <h3 class="text-lg font-medium mb-4">会员行为统计</h3>
        <div ref="behaviorChart" class="h-80"></div>
      </div>
    </div>

    <!-- 头部搜索区域 -->
    <div class="bg-white rounded-lg shadow-sm p-6 mb-6">
      <h1 class="text-2xl font-bold mb-6">会员统计</h1>
      <div class="flex flex-wrap gap-4 items-center">
        <el-input
          v-model="searchForm.nickname"
          placeholder="请输入会员昵称"
          class="w-64"
        />

        <el-date-picker
          v-model="searchForm.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="w-96"
        />

        <el-select
          v-model="searchForm.role"
          placeholder="请选择会员角色"
          class="w-48"
        >
          <el-option
            v-for="role in roleOptions"
            :key="role"
            :label="role"
            :value="role"
          />
        </el-select>

        <el-button
          type="primary"
          class="!rounded-md px-6"
          @click="handleSearch"
        >
          查询
        </el-button>
      </div>
    </div>

    <!-- 数据表格 -->
    <div class="bg-white rounded-lg shadow-sm p-6">
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-lg font-medium">会员详细数据</h3>
        <el-button type="primary" class="!rounded-md px-6" @click="exportData">
          导出数据
        </el-button>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="nickname" label="会员昵称" />
        <el-table-column prop="role" label="会员角色">
          <template #default="{ row }">
            {{ mapRoleToName(row.role) }}
          </template>
        </el-table-column>
        <el-table-column prop="referrals" label="拉新人数" />
        <el-table-column prop="purchases" label="购买数量" />
        <el-table-column prop="shares" label="分享次数" />
        <el-table-column prop="checkins" label="签到次数" />
        <el-table-column prop="redPackets" label="抢红包次数" />
        <el-table-column prop="amount" label="红包金额" />
        <el-table-column prop="create_time" label="创建时间" />
      </el-table>
      <div class="flex justify-end mt-4">
        <el-pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :total="total"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next"
        />
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import StatisticsApi from "@/api/statistics.js";

export default {
  data() {
    return {
      activityTrendData: {
        referrals: [], // 拉新人数
        purchases: [], // 购买数量
        clicks: [] // 小程序码点击
      },
      behaviorTrendData: {
        shares: [], // 分享次数
        checkins: [], // 签到次数
        redPackets: [] // 抢红包次数
      },
      chartDays: [], // 图表日期数据
      roleOptions: ["全部角色", "普通会员", "合伙人"],
      searchForm: {
        nickname: "",
        dateRange: [],
        role: "全部角色" // 默认选中全部角色
      },
      statisticsCards: [],
      currentPage: 1,
      pageSize: 10,
      total: 100,
      tableData: [],
      trendChart: null,
      behaviorChart: null
    };
  },
  mounted() {
    this.initCharts();
    this.getNuserTotal();
    this.getMemberTableData();
    this.getMemberList();
    this.getRoles();
    this.getChartData();
  },

  methods: {
    /*选择时间*/
    changeDate() {
      this.getMemberList();
    },
    // 获取所有图表数据
    getChartData() {
      this.getActivityTrendData();
      this.getBehaviorTrendData();
    },

    // 获取会员活动趋势数据
    getActivityTrendData() {
      // // 默认最近7天
      const search_time = this.searchForm.dateRange;
      console.log("search_time", search_time);
      StatisticsApi.getActivityTrend({
        search_time: JSON.stringify(search_time)
      })
        .then(res => {
          this.chartDays = res.data.days;
          this.activityTrendData = res.data.data;
          // 更新活动趋势图表
          this.updateTrendChart();
        })
        .catch(error => {
          console.error("获取活动趋势数据失败:", error);
        });
    },

    // 获取会员行为统计数据
    getBehaviorTrendData() {
      // 默认最近7天
      const search_time = this.searchForm.dateRange;

      StatisticsApi.getBehaviorTrend({
        search_time: JSON.stringify(search_time)
      })
        .then(res => {
          this.chartDays = res.data.days;
          this.behaviorTrendData = res.data.data;

          // 更新行为统计图表
          this.updateBehaviorChart();
        })
        .catch(error => {
          console.error("获取行为统计数据失败:", error);
        });
    },

    // 更新活动趋势图表
    updateTrendChart() {
      const trend = echarts.init(this.$refs.trendChart);

      trend.setOption({
        animation: false,
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["拉新人数", "购买数量", "小程序码点击"]
        },
        xAxis: {
          type: "category",
          data: this.chartDays
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "拉新人数",
            type: "line",
            data: this.activityTrendData.referrals
          },
          {
            name: "购买数量",
            type: "line",
            data: this.activityTrendData.purchases
          },
          {
            name: "小程序码点击",
            type: "line",
            data: this.activityTrendData.clicks
          }
        ]
      });
    },

    // 更新行为统计图表
    updateBehaviorChart() {
      const behavior = echarts.init(this.$refs.behaviorChart);

      behavior.setOption({
        animation: false,
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["分享次数", "签到次数", "抢红包次数"]
        },
        xAxis: {
          type: "category",
          data: this.chartDays
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "分享次数",
            type: "bar",
            data: this.behaviorTrendData.shares
          },
          {
            name: "签到次数",
            type: "bar",
            data: this.behaviorTrendData.checkins
          },
          {
            name: "抢红包次数",
            type: "bar",
            data: this.behaviorTrendData.redPackets
          }
        ]
      });
    },
    // 获取角色选项
    getRoles() {
      StatisticsApi.getRoles()
        .then(res => {
          // 确保"全部角色"选项在最前面
          if (res.data && Array.isArray(res.data)) {
            this.roleOptions = res.data;
            if (!res.data.includes("全部角色")) {
              this.roleOptions.unshift("全部角色");
            }
          }
        })
        .catch(error => {
          console.error("获取角色选项失败:", error);
        });
    },

    // 角色值映射为显示名称
    mapRoleToName(roleValue) {
      // "全部角色"选项的处理
      if (roleValue === "全部角色" || !roleValue) return "普通会员";

      // 角色值到显示名称的映射
      const roleMap = {
        normal: "普通会员",
        partner: "合伙人"
      };

      return roleMap[roleValue] || roleValue;
    },
    // 获取会员列表数据
    getMemberList(params = {}) {
      StatisticsApi.getMemberList(params, true)
        .then(res => {
          this.tableData = res.data.list || [];
          this.total = res.data.total || 0;
        })
        .catch(error => {
          console.error("获取会员列表失败:", error);
        });
    },
    getMemberTableData() {
      let self = this;
      StatisticsApi.getMemberTableData({}, true)
        .then(res => {
          self.tableData = res.data;
          self.loading = false;
        })
        .catch(error => {});
    },
    /*获取数据*/
    getNuserTotal() {
      let self = this;
      StatisticsApi.getNuserTotal({}, true)
        .then(res => {
          self.statisticsCards = res.data.cards;
          self.loading = false;
        })
        .catch(error => {});
    },
    initCharts() {
      const trend = echarts.init(this.$refs.trendChart);
      const behavior = echarts.init(this.$refs.behaviorChart);

      trend.setOption({
        animation: false,
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["拉新人数", "购买数量", "小程序码点击"]
        },
        xAxis: {
          type: "category",
          data: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"]
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "拉新人数",
            type: "line",
            data: [120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: "购买数量",
            type: "line",
            data: [220, 182, 191, 234, 290, 330, 310]
          },
          {
            name: "小程序码点击",
            type: "line",
            data: [150, 232, 201, 154, 190, 330, 410]
          }
        ]
      });

      behavior.setOption({
        animation: false,
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["分享次数", "签到次数", "抢红包次数"]
        },
        xAxis: {
          type: "category",
          data: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"]
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "分享次数",
            type: "bar",
            data: [320, 332, 301, 334, 390, 330, 320]
          },
          {
            name: "签到次数",
            type: "bar",
            data: [420, 382, 391, 434, 490, 430, 410]
          },
          {
            name: "抢红包次数",
            type: "bar",
            data: [150, 232, 201, 154, 190, 330, 410]
          }
        ]
      });
    },
    // 处理查询操作
    handleSearch() {
      // 构造查询参数
      const params = {
        nickname: this.searchForm.nickname,
        role: this.searchForm.role === "全部角色" ? "" : this.searchForm.role,
        dateRange: this.searchForm.dateRange,
        page: this.currentPage,
        pageSize: this.pageSize
      };

      // 调用API获取数据
      this.getMemberList(params);
    },
    // 处理导出数据
    exportData() {
      // 构造导出参数（与查询参数一致）
      const exportParams = {
        nickname: this.searchForm.nickname,
        role: this.searchForm.role === "全部角色" ? "" : this.searchForm.role,
        dateRange: this.searchForm.dateRange
      };

      StatisticsApi.exportMemberData(exportParams)
        .then(res => {
          // 这里处理导出的业务逻辑
          console.log("导出数据:", res.data);

          // 实际项目中，这里会创建并下载Excel文件
          // this.downloadExcel(res.data);
        })
        .catch(error => {
          console.error("导出数据失败:", error);
        });
    }
  }
};
</script>

<style scoped>
.el-input :deep(.el-input__wrapper) {
  box-shadow: 0 0 0 1px #e5e7eb inset;
}
.el-select :deep(.el-input__wrapper) {
  box-shadow: 0 0 0 1px #e5e7eb inset;
}
.el-date-picker :deep(.el-input__wrapper) {
  box-shadow: 0 0 0 1px #e5e7eb inset;
}
</style>



// WEBPACK FOOTER //
// src/views/statistics/nuser/index.vue